import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallNo({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={8} cy={8} r={8} />
        <path
          d="M5.1 6.1c-.1-.1-.13-.28-.04-.45l.03-.05.02-.02.47-.47a.37.37 0 01.53 0L8 7l1.9-1.9a.37.37 0 01.52 0l.47.47c.15.14.15.38 0 .53L9 8l1.9 1.9c.12.1.14.28.05.45l-.05.07-.47.47a.37.37 0 01-.53 0L8 9l-1.9 1.9a.37.37 0 01-.52 0l-.47-.47a.37.37 0 010-.53L7 8 5.1 6.1z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

SvgTickSmallNo.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallNo.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickSmallNo svgRef={ref} {...props} />);
export default ForwardRef;
